export default __webpack_public_path__ + "static/media/minus-thin-grey.001aa3a1.svg";